/**
 * Public Route Guard
 * 
 * Protects public routes (login, signup) from authenticated users.
 * Redirects authenticated users to the dashboard.
 * 
 * @remarks
 * - Guard behavior is controlled by environment configuration
 * - In development, can be disabled via `environment.auth.enableGuards`
 * - Prevents logged-in users from accessing login/signup pages
 */

import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { RoutePaths } from '../constants';
import { environment } from '../../../environments/environment';

export const publicGuard: CanActivateFn = (route, state) => {
  // Skip guard if disabled in environment config (for development)
  if (!environment.auth.enableGuards) {
    return true;
  }
  
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isLoggedIn()) {
    return true;
  }

  // Redirect to dashboard if already logged in
  router.navigate([RoutePaths.DASHBOARD]);
  return false;
};




